import { request } from '../../libs/http/http';


/** * Listar impuestos configurados en el sistema contable
 * @returns {Promise}
 */

// para la siguiente ruta de backend: 
/* Ruta para listar impuestos del sistema contable
router.get('/contable', 
    controller.listarTaxContable.bind(controller)
);*/

export const listarImpuestosContables = () => {
  return request('get', '/taxes/contable');
};
